export default __webpack_public_path__ + "static/media/dots-gray-bottom-left.ffd7d9c9.svg";